module.exports = __webpack_public_path__ + "img/3.42e53b96.png";